import React from 'react';

interface SubtypePickerCardProps {
  icon: React.ReactNode;
  title: string;
  onClick: () => void;
  disabled?: boolean;
}

/**
 * SubtypePickerCard — icon + title only. Compact, elegant.
 *
 * Motion: subtle lift on hover (gated to `hover: hover` via CSS media query),
 * 0.97 scale on press. Both use custom ease-out curve `cubic-bezier(0.23,1,0.32,1)`.
 */
export default function SubtypePickerCard({
  icon,
  title,
  onClick,
  disabled,
}: SubtypePickerCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="subtype-picker-card group relative flex-shrink-0 flex flex-col items-center justify-center gap-2.5 w-[140px] h-[112px] px-3 rounded-2xl bg-primary-500/[0.06] border border-primary-500/30 text-primary-500 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
    >
      <span className="flex items-center justify-center w-10 h-10 text-primary-500 transition-transform duration-200 [transition-timing-function:cubic-bezier(0.23,1,0.32,1)] group-active:scale-[0.92]">
        {icon}
      </span>
      <span className="font-sans font-bold text-xs leading-4 uppercase tracking-[0.04em] text-primary-500 text-center">
        {title}
      </span>
    </button>
  );
}
